import React, { useCallback, useEffect, useState } from 'react';
import { fetchWheel, fetchClassroomBalloon } from './wheelApi';
import WheelModal from './WheelModal';
import LearnedLettersDialog from './LearnedLettersDialog';
import ClassroomBalloon from '../sound-hunt/ClassroomBalloon';
import ClassroomLaunchScreen from './ClassroomLaunchScreen';

export default function ClassroomActivity({ token, game, onClose, soundEnabled }) {
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(null);
  const [settings, setSettings] = useState(false);
  const [error, setError] = useState('');
  const [refreshing, setRefreshing] = useState(false);
  const load = useCallback(() => game === 'wheel' ? fetchWheel(token) : fetchClassroomBalloon(token), [token, game]);
  const initialLoad = useCallback(() => {
    setError('');
    return load().then(result => { setData(result); if (!result.learned_letters.length) setSettings(true); }).catch(err => setError(err.message));
  }, [load]);
  useEffect(() => { let active = true; load().then(result => { if (active) { setData(result); if (!result.learned_letters.length) setSettings(true); } }).catch(err => { if (active) setError(err.message); }); return () => { active = false; }; }, [load]);
  const resume = async () => {
    setRefreshing(true); setError('');
    try {
      const result = await load();
      if (!data?.learned_letters.length || !data?.entries.length || data?.status === 'insufficient_content') { setData(result); setPending(null); }
      else setPending(result);
      setSettings(false);
    } catch (err) { setSettings(false); setError(err.message); }
    finally { setRefreshing(false); }
  };
  const cancel = () => { setSettings(false); if (!data?.learned_letters.length) onClose(); };
  const openSettings = () => setSettings(true);
  return <>
    {data?.learned_letters.length > 0 && game === 'wheel' && <WheelModal fullScreen content={data} pendingContent={pending} paused={settings || refreshing || Boolean(error)} onSettings={openSettings} onClose={onClose} soundEnabled={soundEnabled} />}
    {data?.learned_letters.length > 0 && game === 'balloon' && <ClassroomBalloon data={data} pendingData={pending} paused={settings || refreshing || Boolean(error)} onSettings={openSettings} onClose={onClose} />}
    {(!data || error) && !settings && <ClassroomLaunchScreen game={game}
      error={error} onRetry={data ? resume : initialLoad} busy={refreshing} onClose={onClose} />}
    {settings && <LearnedLettersDialog token={token} onSaved={resume} onCancel={cancel} />}
  </>;
}
